import { createRef, useRef, useState } from "react";

import { Action, Category } from "@/constants/events";
import { useEventTracker } from "@/hooks/useEventTracker";
import { useSelector } from "@/redux/hooks";
import { getFormattedAddress } from "@/redux/selectors/location";

import AddressCaptureModal from "@/components/AddressCaptureModal";
import { DeliveryValidationButton } from "@/components/botanic/DeliveryValidationModal";

const DeliveryValidation = ({
  trackingCategory,
  trackingLabel,
}: {
  trackingCategory?: Category;
  trackingLabel?: string;
}) => {
  const formattedAddress = useSelector(getFormattedAddress);
  const modalReturnRef = createRef<HTMLButtonElement>();
  const { trackEvent } = useEventTracker();

  const handleClick = () => {
    setModalVisible(true);
    if (trackingCategory) {
      trackEvent(trackingCategory, Action.click, trackingLabel);
    }
  };

  const [modalVisible, setModalVisible] = useState(false);

  const buttonRef = useRef<HTMLButtonElement>(null);

  return (
    <div
      className="w-full"
      data-testid="delivery-validation-btn"
      style={{ maxWidth: "488px" }}
    >
      <AddressCaptureModal
        isVisible={modalVisible}
        onDismissed={() => setModalVisible(false)}
        returnFocusRef={modalReturnRef}
      />
      <DeliveryValidationButton
        className="bg-white"
        address={formattedAddress || undefined}
        ref={buttonRef}
        placeholder="What’s your address?"
        handleClick={handleClick}
      />
    </div>
  );
};

export default DeliveryValidation;
